import { useInventoryListPage } from './list/useInventoryListPage';
import { InventoryListView } from './list/InventoryListView';

const InventoryPage = () => {
    const page = useInventoryListPage();
    return <InventoryListView page={page} />;
};

export default InventoryPage;
